
const config = require ('../../../../configs/configuration.js')
const constants = config.configuration.data;
import {
    _,
    localizeHTMLTag
} from '../lang';

import tooltip from 'bootstrap';

export default function createSocial() {
    'use strict';

    //get container
    const socialContainer = document.getElementById('social-container');

    //recreate
    socialContainer.innerHTML = '';


    let currentLocation = window.location;
    //always append the lang parameter if not already there
    if (currentLocation.href.indexOf('lang') === -1) {
        currentLocation = currentLocation.href + (currentLocation.href.indexOf('?') !== -1 ? "&lang=" + String.locale : "?lang=" + String.locale);
    }

    //check if it is embeded or not
    let isEmbed = (window.top !== window.self) ? true : false;

    const w = window.innerWidth;

    if (w > 1830 || w < 990 || true) {
        if (window.indicators[0].info) {

            let infomark = document.createElement('span');
            infomark.setAttribute('class', 'fa-stack');
            infomark.setAttribute('data-toggle', 'modal');
            infomark.setAttribute('data-target', '#container-modal-instructions');
            infomark.setAttribute('data-tooltip', 'tooltip');
            infomark.setAttribute('data-placement', 'bottom');
            infomark.setAttribute('title', _('instructions-header'));

            let circleInfo = document.createElement('i');
            circleInfo.setAttribute('class', 'fa fa-circle fa-stack-2x');

            let iconInfo = document.createElement('i');
            iconInfo.setAttribute('class', 'fa fa-info fa-stack-1x fa-inverse');

            infomark.appendChild(circleInfo);
            infomark.appendChild(iconInfo);

            socialContainer.appendChild(infomark);
            //localise
            let instructions = document.getElementById('instructions');
            let instructionsText0 = _(window.indicators[0].info);

            let no = new Image();
            no.src = 'img/no.gif';

            instructions.innerHTML = "";

            instructions.appendChild(document.createTextNode(instructionsText0));


            //alert(instructionsText0);
            //add informations

            let informationsHeader = document.getElementById('instructions-header');
            informationsHeader.insertBefore(document.createTextNode(_('instructions-header')), informationsHeader.firstChild);

        }


        let embed = document.createElement('span');
        embed.setAttribute('class', 'fa-layers fa-fw fa-2x');
        embed.setAttribute('data-toggle', 'modal');
        embed.setAttribute('data-target', '#container-modal-embed');
        embed.setAttribute('data-tooltip', 'tooltip');
        embed.setAttribute('data-placement', 'top');
        embed.setAttribute('title', _('embed-icon'));

        let circleEmbed = document.createElement('i');
        circleEmbed.setAttribute('class', 'fas fa-circle');
        let iconEmbed = document.createElement('i');
        iconEmbed.setAttribute('class', 'fas fa-code fa-inverse');
        iconEmbed.setAttribute('data-fa-transform', 'shrink-7');

        embed.appendChild(circleEmbed);
        embed.appendChild(iconEmbed);

        socialContainer.appendChild(embed);


        let twitter = document.createElement('span');
        twitter.setAttribute('class', 'fa-layers fa-2x');
        twitter.setAttribute('data-tooltip', 'tooltip');
        twitter.setAttribute('data-placement', 'top');
        twitter.setAttribute('title', _('twitter-icon'));
        twitter.setAttribute('id', 'twitterButton');

        let circleTwitter = document.createElement('i');
        circleTwitter.setAttribute('class', 'fas fa-circle');

        let iconTwitter = document.createElement('i');
        iconTwitter.setAttribute('class', 'fab fa-twitter fa-inverse');
        iconTwitter.setAttribute('data-fa-transform', 'shrink-7 down-.25 right-.25');

        twitter.appendChild(circleTwitter);
        twitter.appendChild(iconTwitter);

        let twitterLink = document.createElement('a');
        twitterLink.appendChild(twitter);
        let twitterHashtags = encodeURIComponent(_("twitter-hashtags"));
        twitterLink.addEventListener('click', () => {
  
            const chapter = window.indicators[0].code.replace(/\./g, '_');
            var sharingText = _(`indicator${chapter}.sharing.text`);
            window.open('https://twitter.com/intent/tweet?' +
                "hashtags=" + encodeURIComponent(_(`indicator${chapter}.sharing.hashtags`)) +
                '&text=' + sharingText + //' pic.twitter.com/xtihHf0oZn' +            
                '&original_referer=' + currentLocation +
                '&tw_p=tweetbutton&' +
                'url=' + currentLocation + '',
                '_blank',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
            return false;
        });

        socialContainer.appendChild(twitterLink);

        let fb = document.createElement('span');
        fb.setAttribute('class', 'fa-layers fa-fw fa-2x');
        fb.setAttribute('data-tooltip', 'tooltip');
        fb.setAttribute('data-placement', 'top');
        fb.setAttribute('title', _('facebook-icon'));

        let circleFacebook = document.createElement('i');
        circleFacebook.setAttribute('class', 'fas fa-circle');

        let iconFacebook = document.createElement('i');
        iconFacebook.setAttribute('class', 'fab fa-facebook-f fa-inverse');
        iconFacebook.setAttribute('data-fa-transform', 'shrink-7');

        fb.appendChild(circleFacebook);
        fb.appendChild(iconFacebook);


        let fbLink = document.createElement('a');
        fbLink.appendChild(fb);
        fbLink.addEventListener('click', () => {
            let u = window.location.href;
            let t = _('title');
            let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t);
            window.open(url + '?redirect=facebook', 'sharer', 'toolbar=0,status=0,width=626,height=436');
        });
        socialContainer.appendChild(fbLink);

        let embedContainer = document.getElementById('embed');
        embedContainer.innerHTML = '<pre class="pre-scrollable"><code>&lt;iframe width="100%" height="800" src="' + currentLocation + '"&gt;&lt;/iframe&gt;</code></pre>';


        let embedHeader = document.getElementById('embed-header');
        embedHeader.innerHTML = '';
        embedHeader.insertBefore(document.createTextNode(_('embed_instruction')), embedHeader.firstChild);

        let closeButton = document.createElement('button');
        closeButton.setAttribute('type', 'button');
        closeButton.setAttribute('class', 'close');
        closeButton.setAttribute('data-dismiss', 'modal');
        closeButton.setAttribute('aria-label', _('close'));

        let spanButton = document.createElement('span');
        spanButton.setAttribute('aria-hidden', 'true');
        spanButton.innerHTML = '&times';
        closeButton.appendChild(spanButton);

        embedHeader.appendChild(closeButton);


    } else {
        window.indicators = window.appData[currentId];
        if (window.indicators[0].info) {

            let infomark = document.createElement('span');
            infomark.setAttribute('class', 'fa-stack');
            infomark.setAttribute('data-toggle', 'modal');
            infomark.setAttribute('data-target', '#container-modal-instructions');
            infomark.setAttribute('data-tooltip', 'tooltip');
            infomark.setAttribute('data-placement', 'bottom');
            infomark.setAttribute('title', _('instructions-header'));

            let circleInfo = document.createElement('i');
            circleInfo.setAttribute('class', 'fa fa-circle fa-stack-2x');

            let iconInfo = document.createElement('i');
            iconInfo.setAttribute('class', 'fa fa-info fa-stack-1x fa-inverse');

            infomark.appendChild(circleInfo);
            infomark.appendChild(iconInfo);

            socialContainer.appendChild(infomark);
            //localise
            let instructions = document.getElementById('instructions');
            let instructionsText0 = _(window.indicators[0].info);

            let no = new Image();
            no.src = 'img/no.gif';

            instructions.innerHTML = "";

            instructions.appendChild(document.createTextNode(instructionsText0));


            //alert(instructionsText0);
            //add informations

            let informationsHeader = document.getElementById('instructions-header');
            informationsHeader.insertBefore(document.createTextNode(_('instructions-header')), informationsHeader.firstChild);

        }

        let iconFacebook = document.createElement('i');
        iconFacebook.setAttribute('class', 'fab fa-facebook-f fa-3x fa-fw');
        iconFacebook.setAttribute('style', 'margin-right: 5px;');

        let textFacebook = document.createTextNode(_('facebook-icon'));

        let fbLink = document.createElement('a');
        fbLink.setAttribute('class', 'list-group-item');
        fbLink.appendChild(iconFacebook);
        fbLink.appendChild(textFacebook);

        fbLink.addEventListener('click', () => {
            let u = window.location.href;
            let t = _('title');
            let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(u) + '&t=' + encodeURIComponent(t);
            window.open(url + '?redirect=facebook', 'sharer', 'toolbar=0,status=0,width=626,height=436');
        });


        let iconTwitter = document.createElement('i');
        iconTwitter.setAttribute('class', 'fab fa-twitter fa-3x fa-fw');
        iconTwitter.setAttribute('style', 'margin-right: 5px;');

        let textTwitter = document.createTextNode(_('twitter-icon'));

        let twitterLink = document.createElement('a');
        twitterLink.setAttribute('class', 'list-group-item');
        twitterLink.appendChild(iconTwitter);
        twitterLink.appendChild(textTwitter);
        twitterLink.setAttribute('id', 'twitterButton');

        twitterLink.addEventListener('click', () => {
            const chapter = window.indicators[0].code.replace(/\./g, '_');
            var sharingText = _(`indicator${chapter}.sharing.text`);
            window.open('https://twitter.com/intent/tweet?' +
                "hashtags=" + encodeURIComponent(_(`indicator${chapter}.sharing.hashtags`)) +
                '&text=' + sharingText + //' pic.twitter.com/xtihHf0oZn' +            
                '&original_referer=' + currentLocation +
                '&tw_p=tweetbutton&' +
                'url=' + currentLocation + '',
                '_blank',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
            return false;
        });



        let embedContainer = document.createElement('pre');
        embedContainer.setAttribute('class', 'pre-scrollable');
        embedContainer.innerHTML = '<pre class="pre-scrollable"><code>&lt;iframe width="100%" height="800" src="' + currentLocation + '"&gt;&lt;/iframe&gt;</code></pre>';

        let embedHeader = document.createElement('h6');
        embedHeader.insertBefore(document.createTextNode(_('embed_instruction_2')), embedHeader.firstChild);

        let embedSpace = document.createElement('br');

        let share = document.createElement('span');
        share.setAttribute('class', 'fa-layers fa-fw fa-2x');
        share.setAttribute('data-tooltip', 'tooltip');
        share.setAttribute('data-placement', 'top');
        share.setAttribute('title', _('share-icon'));
        share.setAttribute('data-toggle', 'modal');
        share.setAttribute('data-target', '#container-modal-share');


        let circleShare = document.createElement('i');
        circleShare.setAttribute('class', 'fas fa-circle');

        let iconShare = document.createElement('i');
        iconShare.setAttribute('class', 'fas fa-share-alt fa-inverse');
        iconShare.setAttribute('data-fa-transform', 'shrink-7');

        share.appendChild(circleShare);
        share.appendChild(iconShare);

        socialContainer.innerHTML = '';
        socialContainer.appendChild(share);


        let shareHeader = document.getElementById('share-header');
        shareHeader.innerHTML = '';

        let closeButton = document.createElement('button');
        closeButton.setAttribute('type', 'button');
        closeButton.setAttribute('class', 'close');
        closeButton.setAttribute('data-dismiss', 'modal');
        closeButton.setAttribute('aria-label', _('close'));

        let spanButton = document.createElement('span');
        spanButton.setAttribute('aria-hidden', 'true');
        spanButton.innerHTML = '&times';
        closeButton.appendChild(spanButton);


        shareHeader.insertBefore(document.createTextNode(_('share-header')), shareHeader.firstChild);
        shareHeader.appendChild(closeButton);

        let shareList = document.getElementById('share-list');
        shareList.innerHTML = '';
        shareList.appendChild(fbLink);
        shareList.appendChild(twitterLink);
        shareList.appendChild(embedSpace);
        shareList.appendChild(embedSpace);
        shareList.appendChild(embedHeader);
        shareList.appendChild(embedContainer);

    }
    $('[data-tooltip="tooltip"]').tooltip();

}